import React, { Component } from 'react';

export default class GroupMeView extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

        this.generateOptions = this.generateOptions.bind(this);
    }

    generateOptions() {
        let result = [];

        result.push((<div className={"material-icons group-add-button"} onClick={this.props.setManageActive.bind(null, true, true)}>{"add"}</div>))

        let myGroupsJsx = []

        _.sortBy(this.props.myGroups, x => x.name).forEach(group => {
            myGroupsJsx.push((
                <div key={"group" + group.groupId} className={"card-item-outer" + (this.props.activeGroupId === group.groupId ? " active" : "")}>
                    <div className={"icon-container"} onClick={this.props.setMyActiveGroupId.bind(null, group.groupId)}>
                        <div className={"material-icons icon"}>{"group"}</div>
                    </div>
                    <div className={"name-container"} onClick={this.props.setMyActiveGroupId.bind(null, group.groupId)}>
                        <div className={"main-text"}>{group.name}</div>
                        <div className={"sub-text"}>{"Location Pool: " + (group.myLocationMembers.length + group.yourLocationMembers.length)}</div>
                    </div>
                    <div className={"bottom-container"}>
                        <div className={"material-icons bottom-item"} onClick={this.props.showScanCode.bind(null, group.joinCode, (<span>{group.name}<br />Join Code</span>))}>{"store_mall_directory"}</div>
                        <div className={"material-icons bottom-item"} onClick={this.props.showScanCode.bind(null, group.viewCode, (<span>{group.name}<br />View Code</span>))}>{"account_circle"}</div>
                        <div className={"material-icons bottom-item"} onClick={this.props.setManageActive.bind(null, true, false)}>{"edit"}</div>
                        <div className={"material-icons bottom-item"} onClick={this.props.deleteGroup.bind(null, group)}>{"delete"}</div>
                    </div>
                </div>
            ));
        });

        result.push((
            <div className={"card-container no-pad"}>
                {myGroupsJsx}
            </div>
        ))

        return result;
    }

    render() {

        let optionsJsx = this.generateOptions();

        return (
            <div className={"group-main stackup-group-me-outer" + (this.props.isActive ? "" : " hidden") + (this.props.isCenter ? "" : " off")}>
                {optionsJsx}
            </div>
        );
    }
}

